import { Injectable, NgZone } from '@angular/core';
import { LogoutService } from './logout.service';

@Injectable({
  providedIn: 'root'
})
export class StorageMonitorService {
  private intervalId: any;

  constructor(
    private logoutService: LogoutService,
    private ngZone: NgZone
  ) {}

  startMonitoring() {
    this.ngZone.runOutsideAngular(() => {
      this.intervalId = setInterval(() => {
        this.checkLocalStorage();
      }, 3500); // Verifica a cada segundo
    });
  }

  stopMonitoring() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private checkLocalStorage() {
    const mlct = localStorage.getItem('mlct');
    if (!mlct) {
      this.ngZone.run(() => {
        localStorage.clear();
        this.logoutService.logout();
      });
    }
  }
}
